import { API, classApi, paymentUpdate, reportAPI } from '@/api'
import { IPaymentReportFilters } from '../components/Filters/Filters'

export const updatePaymentStatus = async (): Promise<boolean> => {
  try {
    const res = await paymentUpdate.update()
    return res?.data.status === 'success'
  } catch (error) {
    console.error('Ошибка обновления:', error)
    return false
  }
}

export const removePayment = async (id: number): Promise<boolean> => {
  try {
    const res = await reportAPI.payments.paymentsRemove(id)
    return res?.data.status === 'success'
  } catch (error) {
    console.error('Ошибка удаления платежа:', error)
    return false
  }
}

export const updatePaymentAmount = async (
  id: number,
  amount: number,
): Promise<boolean> => {
  try {
    const data = new FormData()
    data.append('id', String(id))
    data.append('amount', String(amount))

    const res = await reportAPI.payments.updateAmount(data)
    return res?.data.status === 'success'
  } catch (error) {
    console.error('Ошибка обновления платежа:', error)
    return false
  }
}

export const updatePaymentComment = async (
  id: number,
  comment: string,
): Promise<boolean> => {
  try {
    const res = await reportAPI.payments.updateComment({ id, comment })
    return res?.data.status === 'success'
  } catch (error) {
    console.error('Ошибка обновления комментария платежа:', error)
    return false
  }
}

export const getClassesIndex = async (): Promise<IClass[]> => {
  try {
    const res = await classApi.index({ expand: ['supervisor'] })
    return res?.data.data ?? []
  } catch (error) {
    console.error('Ошибка получения классов:', error)
    return []
  }
}

export const downloadPaymentsReport = async (
  filters: IPaymentReportFilters,
): Promise<boolean> => {
  try {
    const params: Record<string, string> = {
      courseId: filters.courseId,
      status: filters.status,
      type: filters.type,
    }

    if (filters?.startDate) {
      params.startDate = filters.startDate
    }
    if (filters?.endDate) {
      params.endDate = filters.endDate
    }
    if (filters.classMode === 'class' && !!filters?.classIds) {
      params.classIds = JSON.stringify(filters.classIds)
    }
    if (filters.classMode === 'folder' && !!filters?.classFolderIds) {
      params.classFolderIds = JSON.stringify(filters.classFolderIds)
    }
    if (filters.franchiseIds?.length) {
      params.franchiseIds = filters.franchiseIds.join(',')
    }

    const res = await API.get('reports/payments-to-excel', {
      responseType: 'blob',
      params,
    })

    if (res?.data) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Payments.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      return true
    }
    return false
  } catch (error) {
    console.error('Ошибка скачивания отчета:', error)
    return false
  }
}
